/* 
 	* 车辆档案之OBD故障组件 
 	* 描述：对应车辆的OBD故障列表，包括查询功能
 	* 创建时间：2017-03-31
 	* 创建人：Shujuan Sun 
 	* 修改时间：
*/
<template>
	<div class="pl10px pr10px" v-loading="loadingstatus" element-loading-text="加载中">
		<!--表单部分开始-->
		<div class="form-horizontal ibox-content">
			<div class="form-group">
				<label class="col-sm-1 control-label ">设备ID</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.displayDeviceid">
				</div>
				<label class="col-sm-1 control-label focus_color">*设备编号</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.deviceNum" >
				</div>
				<label class="col-sm-1 control-label focus_color">*设备类型</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.obdFlag">
				</div>		
			</div>
			
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">指令名称</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="queryParam.cmdName" maxlength="10">
				</div>
				<label class="col-sm-1 control-label t_center">指令类型</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="queryParam.cmdType" >
						<option v-for="option in cmdType" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label t_center">指令发出人</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="queryParam.userId" maxlength="10">
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_left">投诉开始时间</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.sendTimeStart" class="form-control" ref="dateFrom"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label t_center">投诉结束时间</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.sendTimeEnd" class="form-control" ref="dateTo"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label t_center">指令响应结果</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="queryParam.status" >
						<option v-for="option in cmdStatus" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right" v-if="levv==1" key="user-didi">
					<button v-if="permissionD.indexOf('fileCarList_historyCommandReset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
					<button v-if="permissionD.indexOf('fileCarList_historyCommandSelect') == -1" class="btn btn-primary" @click="searchInfo" :disabled="!validDates">查询</button>
				</div>
				<div class="col-sm-12 text-right" v-else key="user-rb">
					<button v-if="permission.indexOf('carFileList_historyCommandReset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
					<button v-if="permission.indexOf('carFileList_historyCommandSelect') == -1" class="btn btn-primary" @click="searchInfo" :disabled="!validDates">查询</button>
				</div>
			</div>
		</div>
		<br />
		<!--表单部分结束-->
		<!--列表部分开始-->
		<div class="table-responsive">
			<table class="table table-striped table-bordered table-hover">
				<thead>
					<tr role="row">
						<th>指令名称</th>
						<th>指令类型</th>
						<th>指令时间</th>
						<th>指令发出人</th>
						<th>指令响应结果</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="info in infoList">
						<td>{{info.cmdName}}</td>
						<td>{{info.cmdTypeName}}</td>
						<td>{{info.sendTime}}</td>
						<td>{{info.userName}}</td>
						<td>{{info.statusName}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<!--列表部分结束-->
		<!--分页组件开始-->
		<pagination
			v-if="infoList.length>0"
			:pageInfo="pageInfo"
			v-on:getData="getPageNo"
			>						
		</pagination>
		<!--分页组件结束-->
	</div>
</template>
<script>
	import Pagination from 'components/common/Pagination'
	import Datepicker from 'components/common/datepicker/Datepicker' 
	import {DICTIONARY_MAP} from 'static/constant'
	import {OPERATE_EXCEPTION} from 'static/message'
	import {getDictionaryFromArray} from 'util/util'
	export default {
		name: 'HistoryInstruction',
		components:{
			Pagination,
			Datepicker
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["carFileList"]?this.$store.state.permission.permission["carFileList"]:[],
				permissionD:this.$store.state.permission.permission["fileCarList"]?this.$store.state.permission.permission["fileCarList"]:[],
				loadingstatus:false,
				deviceInfo:{
					displayDeviceid:'VD' + this.$parent.deviceInfo.deviceid,
					deviceid:this.$parent.deviceInfo.deviceid,
					deviceNum:this.$parent.deviceInfo.deviceNum,
					obdFlag:this.$parent.deviceInfo.obdFlag
				},
				//以下为查询属性
				queryParam:{
					deviceId:this.$parent.deviceInfo.deviceid,//设备ID
					cmdName:'',						//指令名称
					cmdType:'',						//指令类型
					userId:'',						//指令发出人
					status:'',						//指令响应结果
					sendTimeStart: '',				//查询开始时间
			    	sendTimeEnd: '',				//查询结束时间
			    	page_index: 1,
				},
				udcType:[
				DICTIONARY_MAP.CMD_TYPE,
				DICTIONARY_MAP.CMD_STATUS
				],
				cmdType:[{udccode:'',udcname:'全部'}],
				cmdStatus:[{udccode:'',udcname:'全部'}],
				infoList:[],					    //从接口获取的表格数据
				pageInfo:{},						//传给分页组件的属性对象
				pageNo:1,							//从分页组件获取的当前页码数
			}
		},
		beforeMount(){
			this.getUdc();
			this.getCmdInfo();
			
		},
		computed: {
			levv(){
				return this.$store.state.user.levv
			},
		   //	起止时间是否合法
			validDates: function(){
				if(this.queryParam.sendTimeStart && this.queryParam.sendTimeEnd && this.queryParam.sendTimeStart > this.queryParam.sendTimeEnd){
					return false;
				} else {
					return true;
				}
			}
		},
		methods:{
			//查询方法
			searchInfo(){
				this.queryParam.page_index = 1;
				this.getCmdInfo();
			},
			//获取指令一览信息
			getCmdInfo() { 
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT + "/vehicle/vehicles/" + this.$parent.queryparam.vehicleid +"/devices/"+this.$parent.queryparam.deviceid+'/commands', {params: this.queryParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;								
						const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
						this.pageInfo = {
							pageNum: pageNum,
							pages: pages,
							total: total,
							isFirstPage: isFirstPage,
							isLastPage: isLastPage
						}
						this.infoList = resInfo.list;
					} else {
						this.$parent.openModal(res.data.message);
					}
					this.loadingstatus = false;
				}, res => {
					this.$parent.openModal(res.data.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})
			},
			//从分页组件获取页码参数
			getPageNo(pageNo) { 
				this.pageNo = pageNo;
				this.queryParam.page_index = pageNo;
				this.getCmdInfo();
			},
			getUdc(){
				if(this.udcType.length ==0) return;			
				let param = this.udcType.join(',');
				this.$http.get(process.env.API_ROOT + '/system/udcs',{params:{udcTypes: param}})
				.then(res => {
					if(res.data.success){			
					 	this.cmdType.push.apply(this.cmdType,getDictionaryFromArray(res.data.data,DICTIONARY_MAP.CMD_TYPE));
					 	this.cmdStatus.push.apply(this.cmdStatus,getDictionaryFromArray(res.data.data,DICTIONARY_MAP.CMD_STATUS));
					}else{
						this.$parent.openModal(res.data.message+'message');
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})		
			},
			resetQueryParams:function(){
				this.$refs.dateFrom.handleClear();
				this.$refs.dateTo.handleClear();
				this.queryParam = {
					cmdName:'',						//指令名称
					cmdType:'',						//指令类型
					userId:'',						//指令发出人
					status:'',						//指令响应结果
					sendTimeStart: '',				//查询开始时间
			    	sendTimeEnd: '',				//查询结束时间
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// HistoryInstruction.vue?0861630f